import { IBaseComponentProps } from "../props/IBaseComponentProps";
import Styles from './NSLoading.module.css';

export interface NSLoadingProps extends IBaseComponentProps
{
	title?: string;
	desciption?: string;
	small?: boolean;
	hideContainer?: boolean;
	hideTitle?: boolean;
	hideDesciption?: boolean;
}

export function NSLoading(props: NSLoadingProps)
{
	let content = <>
		{
			!(props.hideTitle ?? false) &&
			<h5>{props.title ?? "Loading"}</h5>
		}
		<span className={`${Styles.ns_loader} ${props.small ? Styles.ns_loader_small : Styles.ns_loader_big}`}></span>
		{
			!(props.hideDesciption ?? false) &&
			<p>{props.desciption ?? "Please wait ..."}</p>
		}
	</>;
	if (props.hideContainer)
		return content;
	return (
		<div
			id={props.id}
			className={`${Styles.ns_loading_parent} ${props.classList?.join(" ") ?? ""} `}
			style={props.style}
		>
			{content}
		</div>
	);
}